import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "profilePictureFilled"
const ProfilePictureFilledIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M10.582 11.352C10.757 11.554 10.972 11.716 11.215 11.828 11.457 11.94 11.72 11.998 11.988 12S12.52 11.946 12.764 11.837C13.008 11.73 13.225 11.57 13.403 11.37L13.683 11.618 13.965 11.867C13.716 12.147 13.411 12.37 13.07 12.522S12.358 12.752 11.984 12.75 11.24 12.665 10.9 12.509C10.561 12.352 10.26 12.125 10.014 11.842L10.298 11.598zM10.125 8.25C10.539 8.25 10.875 8.586 10.875 9S10.539 9.75 10.125 9.75 9.375 9.414 9.375 9 9.711 8.25 10.125 8.25M13.875 8.25C14.289 8.25 14.625 8.586 14.625 9S14.289 9.75 13.875 9.75 13.125 9.414 13.125 9 13.461 8.25 13.875 8.25" />
          <path
            fillRule="evenodd"
            d="M18.75 1.5C19.578 1.5 20.25 2.172 20.25 3V21C20.25 21.57 19.932 22.064 19.465 22.318 19.252 22.434 19.009 22.5 18.75 22.5H5.25Q5.172 22.5 5.097 22.492C4.34 22.415 3.75 21.777 3.75 21V3C3.75 2.172 4.422 1.5 5.25 1.5zM12.364 15.568C10.18 15.502 8.019 16.026 6.106 17.082Q5.666 17.326 5.25 17.604V21H18.75V17.604Q18.636 17.527 18.52 17.453C16.674 16.284 14.548 15.633 12.364 15.568M12 4.875C9.308 4.875 7.125 7.058 7.125 9.75S9.308 14.625 12 14.625 16.875 12.442 16.875 9.75 14.692 4.875 12 4.875"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default ProfilePictureFilledIcon
